import { render, staticRenderFns } from "./staffSummaryPk.vue?vue&type=template&id=0080c0a5&"
import script from "./staffSummaryPk.vue?vue&type=script&lang=js&"
export * from "./staffSummaryPk.vue?vue&type=script&lang=js&"
import style0 from "./staffSummaryPk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports